import React from 'react';

import ENUMS from '../../../enums';
import { enumHelper } from '../../../utils';

import ShowForPermission from '../../../components/ShowForPermission';

function ReserveRequestListTableRow(props) {
  const {
    pageNumber,
    pageSize,
    ix,
    createdFullName,
    isSuspended,
    createdAt,
    startAt,
    endAt,
    reservedTables,
    reserveType,
    trackingNumber,
    persons,
    meal,
    cafeName
  } = props;

  const displayReserveDetailsModal = e => {
    e.preventDefault();

    props.displayReserveDetailsModal(props.id);
  };

  return (
    <tr className={`${isSuspended ? 'danger-row' : ''}`}>
      <td className="text-center">{(pageNumber - 1) * pageSize + ix + 1}</td>
      <td className="text-center">{createdFullName}</td>
      <td className="text-center">{createdAt}</td>
      <td className="text-center">{startAt}</td>
      <td className="text-center">{endAt}</td>
      <td className="text-center">
        {reservedTables &&
          reservedTables.length &&
          reservedTables.map(
            (ele, index, self) => ` ${ele.num} ${index < self.length - 1 ? '،' : ''}`
          )}
      </td>
      <td className="text-center">
        {enumHelper.convertEnumValueToTitle(ENUMS.RESERVATION_TYPES.list, reserveType)}
      </td>
      <td className="text-center direction-ltr">{trackingNumber}</td>
      <td className="text-center">{persons}</td>
      <td className="text-center">
        {enumHelper.convertEnumValueToTitle(ENUMS.MEAL_PORTIONS.list, meal)}
      </td>
      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_REQUESTS_RESERVES_FOR_ADMIN}>
        <td className="text-center">{cafeName}</td>
      </ShowForPermission>
      <td className="text-center pointer">
        <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_RESERVE_DETAILS}>
          <a
            href="#"
            title={locales('titles.editRequestedReservation')}
            onClick={displayReserveDetailsModal}
          >
            <i className="far fa-info-circle" />
          </a>
        </ShowForPermission>
      </td>
    </tr>
  );
}

export default ReserveRequestListTableRow;
